module.exports = __webpack_public_path__ + "img/img2.46d860d3.jpg";